import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/trajetoria")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="timeline"
      label="Trajetória"
      fields={[
        { name: "year", label: "Ano", type: "text", required: true },
        { name: "title", label: "Título", type: "text", required: true },
        { name: "description", label: "Descrição", type: "textarea" },
        { name: "image_url", label: "Imagem", type: "image" },
        { name: "sort_order", label: "Ordem", type: "number" },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Rascunho", value: "draft" },
            { label: "Publicado", value: "published" },
            { label: "Oculto", value: "hidden" },
          ],
        },
      ]}
      columns={[
        { key: "year", label: "Ano" },
        { key: "title", label: "Título" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
